// extracted by mini-css-extract-plugin
export default {"titleTable":"PreviouslyCompletedCredits_titleTable__Smzh+","row":"PreviouslyCompletedCredits_row__RC3Ei"};